import axios from 'axios'
import qs from 'qs'
import baseUrl from './env.js'
import router from '../router'

const install = function (Vue) {
  const _val = new Vue()
  // axios.defaults.withCredentials = true
  /**
   *  添加请求拦截器
   */
  axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    config.headers.Authorization = 'Bearer ' + localStorage.getItem('accessToken')
    //如果不是get提交。那么就要加锁，防止表单提交
    return config
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  })

  /**
   * 添加响应拦截器
   */
  axios.interceptors.response.use(res => {
    if (res.data.code === 700) { //token失效
      localStorage.removeItem('accessToken')
      localStorage.removeItem('grade')
      localStorage.removeItem('payContent')
      localStorage.removeItem('balance')
      _val.$bus.$emit('loginBus')
      _val.$Message.info('请登录');
      router.push({ path: '/Login' })
      return
    }
    return res.data
  }, function (error) {
    console.log(error.response)
    if (error.response){
      if (error.response.status == 500){
        _val.$Message.info("【" + error.response.status + "】请求出错了" + JSON.stringify(error.response.data.message));
      }else{
        _val.$Message.info("【" + error.response.status + "】请求出错了" + JSON.stringify(error.response.data));
      }
    }else {
      _val.$Message.info( "请求出错了：" + error.message)
    }
    return Promise.reject(error)
  })

  let service = function (url, data) {
    let option = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        // 'Content-Type': 'multipart/form-data',
      },
      data: qs.stringify(data),
      // data: data,
      url: baseUrl + url,
      timeout: 5000
    }
    return axios(option)
  }
  let service1 = function (url, data) {
    let option = {
      method: 'POST',
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'Content-Type': 'application/json',
      },
      dataType: 'json',
      data: data,
      // data: data,
      url: baseUrl + url,
      // timeout: 60000
      timeout: 1800000
    }
    return axios(option)
  }
  let exportService = function (url,data) {
    let option = {
      method: 'POST',
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        // 'Content-Type': 'application/json',
      },
      dataType: 'json',
      data: qs.stringify(data),
      // data: data,
      url: baseUrl + url,
      timeout: 5000
    }
    return axios(option)
  }

  Vue.prototype.$http = service
  Vue.prototype.$http1 = service1
  Vue.prototype.$exportService = exportService
}
export default install
